export type CalendarFilterOption = {
  id: number;
  label: string;
};

export type CalendarFilterMode = "users" | "resources";

export type CalendarFilterValue = {
  locationId?: number | null;
  users: number[];
  services: number[];
  resources: number[];
  days: number[];
  calendarMode?: CalendarFilterMode;
  timeStep?: number;
  showOnlyUsersWithShifts?: boolean;
  showStaffNames?: boolean;
  showOnlyFixedAppointments?: boolean;
};

/** dayjs weekday numbering — Sunday is 0, as the stored calendar filter uses. */
export const CALENDAR_FILTER_DAY_IDS = [0, 1, 2, 3, 4, 5, 6];
